import React from 'react';

import { Box, useMantineTheme } from '@mantine/core';
import { buildSmartAssistantLinearGradientStyle } from 'shared/utils/smart-assistant';

interface GradientSwatchProps {
  colors: string[];
  size?: number;
}

export function GradientSwatch({ colors, size = 18 }: GradientSwatchProps) {
  const theme = useMantineTheme();

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `1px solid ${theme.colors.gray[3]}`
      }}>
      <Box
        sx={{
          width: size - 2,
          height: size - 2,
          borderRadius: '50%',
          ...buildSmartAssistantLinearGradientStyle(colors),
          filter: 'blur(1px)'
        }}></Box>
    </Box>
  );
}
